import React from "react";
import { useHistory } from "react-router-dom";
import CustomIcons from "../../../../../components/icons/kIcons.component";
import jwtDecode from "jwt-decode";

export default function DashApplicationDetails(props) {
  let tokenData = props?.state?.payload ? jwtDecode(props.state.payload) : {};
  const capitalizeFirst = (text) => {
    if (!text) return "";
    const str = text.toString();
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  const history = useHistory();

  const getStatusLabel = () => {
    const isCompany = props?.data?.is_company_user || [0, 4, 5, 6].includes(Number(props.userType));

    if (isCompany) {
      if (props?.data?.is_company_user) {
        const s = props?.data?.parent_company?.status !== undefined ? props?.data?.parent_company?.status :
          props?.applications?.application_status !== undefined ? props?.applications?.application_status :
            props?.data?.applicants?.application_status !== undefined ? props?.data?.applicants?.application_status :
              props?.appData?.application_status;

        if (s !== undefined && s !== null) {
          return s === 0 ? "Pending" :
            s === 1 ? "Submitted" :
              s === 2 ? "Approved" :
                s === 3 ? "In Progress" :
                  s === 5 ? "Reverted" :
                    s === 4 ? "Rejected" :
                      s === 6 ? "Agreement Execution" :
                        s === 7 ? "Ongoing Project" :
                          s === 8 ? "Completed" :
                            s === 16 ? "Waiting for final approval" :
                              s === 15 ? "Suggestion" : "";
        }
      }

      const s = props?.appData?.application_status;
      if (s !== undefined && s !== null) {
        return s === 0 ? "Pending" :
          s === 1 ? "Submitted" :
            s === 2 ? "Approved" :
              s === 3 ? "In Progress" :
                s === 5 ? "Reverted" :
                  s === 4 ? "Rejected" :
                    s === 6 ? "Agreement Execution" :
                      s === 7 ? "Ongoing Project" :
                        s === 8 ? "Completed" :
                          s === 16 ? "Waiting for final approval" :
                            s === 15 ? "Suggestion" : "";
      }
    }

    if ([9, 8, 10].includes(Number(props.userType))) {
      const s = props?.appData?.approval_status;
      if (s !== undefined && s !== null) {
        return s === 0 ? "Pending" :
          s === 1 ? "Submitted" :
            s === 2 ? "Approved" :
              s === 3 ? "In Progress" :
                s === 5 ? "Reverted" :
                  s === 4 ? "Rejected" :
                    s === 6 ? "Agreement Execution" :
                      s === 7 ? "Ongoing Project" :
                        s === 8 ? "Completed" :
                          s === 16 ? "Waiting for final approval" :
                            s === 15 ? "Suggestion" : "";
      }
    }

    if (Number(props.userType) === 20) {
      const s = props?.appData?.status;
      if (s !== undefined && s !== null) {
        return s === 0 ? "Pending" :
          s === 1 ? "Submitted" :
            s === 2 ? "Accepted" :
              s === 3 ? "Reverted" :
                s === 5 ? "Rejected" :
                  s === 4 ? "Submitted" :
                    s === 9 ? "Deactivated" : "";
      }
    }

    if (Number(props.userType) === 27) {
      const s = props?.appData?.status;
      if (s !== undefined && s !== null) {
        return s === 0 ? "Pending" :
          s === 1 ? "Approved" :
            s === 2 ? "Reverted" :
              s === 3 ? "Rejected" :
                s === 4 ? "Submitted for Acceptance" :
                  s === 5 ? "Reverted to Admin" : "";
      }
    }

    if ([6, 5].includes(Number(props.userType))) {
      const s = props?.appData?.project_status;
      if (s !== undefined && s !== null) {
        return s === 0
          ? "Pending"
          : s === 1
            ? "Submitted for Acceptance"
            : s === 2
              ? "Approved"
              : s === 3
                ? "Super Admin Reverted"
                : s === 4
                  ? "Rejected"
                  : s === 5
                    ? "Reverted"
                    : "";
      }
    }
    return "";
  };

  const applicationId = (props?.data?.is_company_user || [0, 4, 5, 6, 8, 27].includes(Number(props.userType)))
    ? props?.data?.parent_company?.unique_application_ref_no ||
    props?.applications?.unique_application_ref_no ||
    props?.appData?.unique_application_ref_no ||
    props?.data?.applicants?.unique_application_ref_no ||
    props?.data?.unique_application_ref_no ||
    props?.appData?.reference_id
    : null;

  // Determine if action is needed
  const isReverted = (props.userType === 0 && props.appData?.application_status === 5) ||
    (props.userType !== 0 && props.appData?.approval_status === 5) ||
    (props.userType !== 0 && props?.userType === 24 && props?.appData?.status === 7) ||
    (Number(props.userType) === 27 && Number(props.appData?.status) === 2);

  const isProfileUpdateRequired = props.userType !== 0 &&
    props.userType !== 27 &&
    tokenData?.context_type !== "application" &&
    tokenData?.user?.context_type !== "application" &&
    !props?.data?.is_company_user;

  const isJobSeekerUpdate = props.userType === 20 && props.appData?.status !== 9 &&
    (props.appData?.status !== 7 && props.appData?.status !== 9 && props.appData?.status !== 8);

  const hasActionNeeded = isReverted || isProfileUpdateRequired || isJobSeekerUpdate;

  if (Number(props.userType) === 27) {
    const studentData = props.appData;
    const proposals = studentData?.proposals || [];
    const isStudentReverted = Number(studentData?.status) === 2;
    const isStudentRejected = Number(studentData?.status) === 3;
    const revertMessage = studentData?.admin_revert_message || "Reverted for modifications.";

    return (
      <React.Fragment>
        <div className="student-dash-overview font-sans">
          {/* Reverted or Rejected Alert Box */}
          {(isStudentReverted || isStudentRejected) && (
            <div
              className={`alert ${isStudentReverted ? 'alert-warning' : 'alert-danger'} p-4 mb-4 d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3`}
              style={{
                borderRadius: "12px",
                border: isStudentReverted ? "1px solid #ffeeba" : "1px solid #f5c6cb",
                background: isStudentReverted ? "linear-gradient(135deg, #fff3cd 0%, #fff8e1 100%)" : "linear-gradient(135deg, #f8d7da 0%, #fbe9eb 100%)",
                boxShadow: "0 4px 6px rgba(0,0,0,0.05)"
              }}
            >
              <div>
                <h5 className="font-weight-bold mb-1" style={{ color: isStudentReverted ? "#856404" : "#721c24" }}>
                  <i className="fa fa-exclamation-triangle mr-2"></i>
                  {isStudentReverted ? "Application Reverted to User" : "Application Rejected"}
                </h5>
                <p className="mb-0 text-muted" style={{ fontSize: "14px" }}>
                  <strong>Message from Administrator:</strong> {revertMessage}
                </p>
              </div>
              {isStudentReverted && (
                <button
                  className="btn btn-warning px-4 py-2 text-white font-weight-bold"
                  style={{
                    borderRadius: "8px",
                    background: "linear-gradient(135deg, #ffc107 0%, #e0a800 100%)",
                    border: "none",
                    boxShadow: "0 4px 10px rgba(255, 193, 7, 0.3)",
                    minWidth: "140px"
                  }}
                  onClick={() => history.push(studentData?.id ? `/training-reg?id=${studentData.id}` : "/training-reg")}
                >
                  Update Profile
                </button>
              )}
            </div>
          )}

          {/* Profile Status Summary Card */}
          <div className="card border-0 shadow-sm p-4 mb-4 bg-white" style={{ borderRadius: "12px" }}>
            <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center border-bottom pb-3 mb-3 gap-2">
              <div>
                <h4 className="font-weight-bold text-dark mb-1" style={{ fontSize: "18px" }}>
                  Internship Profile Status
                </h4>
                <p className="text-muted mb-0" style={{ fontSize: "13px" }}>
                  Reference ID: <strong>{studentData?.reference_id || "N/A"}</strong>
                </p>
              </div>
              <span
                className="badge px-3 py-2 text-white font-weight-bold"
                style={{
                  borderRadius: "20px",
                  fontSize: "12px",
                  backgroundColor:
                    studentData?.status === 1 ? "#28a745" : // Approved
                      studentData?.status === 2 ? "#ffc107" : // Reverted
                        studentData?.status === 3 ? "#dc3545" : // Rejected
                          studentData?.status === 4 ? "#17a2b8" : // Submitted to Superadmin
                            "#6c757d" // Pending/Draft
                }}
              >
                {getStatusLabel() || "Draft"}
              </span>
            </div>

            <div className="row">
              <div className="col-12 col-md-6 mb-2">
                <span className="text-muted d-block mb-1" style={{ fontSize: "12px" }}>Full Name</span>
                <strong className="text-dark" style={{ fontSize: "15px" }}>{studentData?.full_name || "N/A"}</strong>
              </div>
              <div className="col-12 col-md-6 mb-2">
                <span className="text-muted d-block mb-1" style={{ fontSize: "12px" }}>Email Address</span>
                <strong className="text-dark" style={{ fontSize: "15px" }}>{studentData?.email || "N/A"}</strong>
              </div>
              <div className="col-12 col-md-6 mb-2">
                <span className="text-muted d-block mb-1" style={{ fontSize: "12px" }}>Phone Number</span>
                <strong className="text-dark" style={{ fontSize: "15px" }}>{studentData?.phone_no || "N/A"}</strong>
              </div>
              {/* <div className="col-12 col-md-6 mb-2">
                <span className="text-muted d-block mb-1" style={{ fontSize: "12px" }}>Academic Institution</span>
                <strong className="text-dark" style={{ fontSize: "15px" }}>{studentData?.institution_name || "N/A"}</strong>
              </div> */}
            </div>
          </div>

          {/* Applied Internship Requests (Proposals) Section */}
          <div className="card border-0 shadow-sm p-4 bg-white" style={{ borderRadius: "12px" }}>
            <h4 className="font-weight-bold text-dark mb-3" style={{ fontSize: "18px" }}>
              My Internship Request Submissions ({proposals.length})
            </h4>

            {proposals.length === 0 ? (
              <div className="text-center p-4 bg-light rounded" style={{ border: "1px dashed #dee2e6" }}>
                <i className="fa fa-folder-open mb-2 text-muted" style={{ fontSize: "24px" }}></i>
                <p className="mb-0 text-muted" style={{ fontSize: "14px" }}>
                  You have not submitted any internship request choices yet.
                </p>
                <button
                  className="btn btn-primary btn-sm mt-3 px-3 py-2"
                  style={{ borderRadius: "6px", backgroundColor: "#0a223d", border: "none" }}
                  onClick={() => history.push("/public-internship-proposals")}
                >
                  Browse Internship Postings
                </button>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0">
                  <thead className="thead-light">
                    <tr style={{ fontSize: "12px", textTransform: "uppercase" }}>
                      <th className="font-weight-bold">Preference</th>
                      <th className="font-weight-bold">Internship Discipline</th>
                      <th className="font-weight-bold">Company Name</th>
                      <th className="font-weight-bold text-center">Status</th>
                      <th className="font-weight-bold text-right">Certificate</th>
                    </tr>
                  </thead>
                  <tbody>
                    {proposals.map((prop, idx) => {
                      const req = prop.internship_request || prop.internshipRequest;
                      const companyName = req?.company?.company_name || "N/A";
                      const discipline = req?.internship_discipline || "N/A";
                      const propStatus = prop.status || "pending";

                      // Get proposal status info for badge rendering
                      const getProposalStatusInfo = (status) => {
                        const normalized = status?.toLowerCase();
                        switch (normalized) {
                          case 'join_internship':
                            return { label: 'Shortlisted', class: 'bg-info-soft text-info' };
                          case 'pending':
                            return { label: 'Pending', class: 'bg-warning-soft text-warning' };
                          case 'approved':
                          case 'allotted':
                            return { label: 'Assigned to Company', class: 'bg-info-soft text-info' };
                          case 'doing':
                            return { label: 'Internship in Progress', class: 'bg-primary-soft text-primary' };
                          case 'evaluation':
                            return { label: 'Evaluation Initiated', class: 'bg-warning-soft text-warning' };
                          case 'evaluated':
                            return { label: 'Evaluation Completed', class: 'bg-success-soft text-success' };
                          case 'certified':
                            return { label: 'Certificate Issued', class: 'bg-success-soft text-success' };
                          case 'completed':
                            return { label: 'Internship Completed', class: 'bg-success-soft text-success' };
                          case 'absorbed':
                            return { label: 'Absorbed into Company', class: 'bg-success-soft text-success' };
                          default:
                            return { label: status?.toUpperCase() || '--', class: 'bg-secondary-soft text-secondary' };
                        }
                      };

                      const statusInfo = getProposalStatusInfo(propStatus);

                      return (
                        <tr key={idx} style={{ fontSize: "14px" }}>
                          <td className="font-weight-bold text-muted">
                            #{prop.preference_order}
                          </td>
                          <td>
                            <span className="font-weight-bold text-dark">{discipline}</span>
                          </td>
                          <td>{companyName}</td>
                          <td className="text-center">
                            <span className={`badge ${statusInfo.class} py-2 px-3 font-weight-bold text-capitalize`} style={{ borderRadius: '4px' }}>
                              {statusInfo.label}
                            </span>
                          </td>
                          <td className="text-right">
                            {(() => {
                              const canDownload = ["certified", "completed", "absorbed"].includes(propStatus) && prop.joint_certificate;
                              return (
                                <span title={!canDownload ? "Certificate will be available when you complete the internship" : ""}>
                                  <button
                                    className="btn btn-outline-success btn-sm px-3 py-1 font-weight-bold"
                                    style={{ borderRadius: "6px" }}
                                    disabled={!canDownload}
                                    onClick={() => {
                                      if (canDownload) {
                                        const url = prop.joint_certificate.startsWith("http")
                                          ? prop.joint_certificate
                                          : `${process.env.REACT_APP_BASE_URL.replace(/\/api\/?$/, "")}/storage/${prop.joint_certificate}`;
                                        window.open(url, "_blank");
                                      }
                                    }}
                                  >
                                    <i className="fa fa-download mr-1"></i>
                                  </button>
                                </span>
                              );
                            })()}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div className="muli">



      </div>
    </React.Fragment>
  );
}
